import Cookies from 'js-cookie';

export function setIsSubscribed(isSubscribed) {
  Cookies.set('subscribed', Boolean(isSubscribed), {path: '/'});
}

export function getIsSubscribed() {
  return Cookies.get('subscribed');
}
